import React from 'react';
import { Bar } from 'react-chartjs-2';
import useAuthenticatedData from '../hooks/useAuthenticatedData';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import 'bootstrap/dist/css/bootstrap.min.css';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = (currentMonthTotal) => ({
  animation: false,
  scales: {
    x: {
      stacked: true,
      ticks: {
        color: 'white'
      }
    },
    y: {
      beginAtZero: true,
      stacked: true,
      ticks: {
        color: 'white',
        font: { size: window.innerHeight * 0.018 },
        callback: function (value) {
          if (value >= 1000000) {
            return `$${(value / 1000000).toFixed(2)}M`;
          } else if (value >= 1000) {
            return `$${(value / 1000).toFixed(0)}k`;
          } else {
            return value;
          }
        }
      }
    }
  },
  plugins: {
    datalabels: {
      anchor: 'center',
      align: 'center',
      font: {
        size: window.innerHeight * 0.02,
        weight: 'bold',
      },
      formatter: (value) => {
        if (value >= 1000000) {
          return `$${(value / 1000000).toFixed(2)}M`;
        } else {
          return `$${(value / 1000).toFixed(0)}K`;
        }
      },
      color: 'white',
      textStrokeColor: 'black',
      textStrokeWidth: 4,
      display: (context) => {
        const currentValue = context.dataset.data[context.dataIndex];
        const threshold = currentMonthTotal * 0.1; // 10% of the current month's total value
        return currentValue >= threshold;
      },
    },
    legend: {
      position: 'bottom',
      labels: {
        font: {
          size: window.innerHeight * 0.018
        },
        color: 'white'
      }
    }
  }
});

/* function formatFigure(x) {
  if (x >= 1000000) {
    return `${(x / 1000000).toFixed(2)}M`;
  }
  if (x >= 1000) {
    return `${(x / 1000).toFixed(2)}K`;
  }
  return x.toFixed(2);
} */

function formatDollarValue(num) {
  const isNegative = num < 0;
  const absNum = Math.floor(Math.abs(num)); // remove decimals
  const formattedValue = `${isNegative ? '-$' : '$'}${absNum.toLocaleString('en-US')}`;
  return formattedValue;
}


const SalesBacklogChart = () => {
 // const { data, isLoading, error } = useAuthenticatedData('https://localhost:5001/monitor/sales-backlog');
 const apiUrl = process.env.REACT_APP_CONTROL_API_URL;
 var url = apiUrl + 'monitor/sales-backlog';
 const { data, isLoading, error } = useAuthenticatedData(url);

  if ((data != null) && (data.chartData != null)) {
    return (
      <div style={{ textAlign: 'center', backgroundColor: 'black' }}>
        <p style={{ fontSize: '2.5vh', color: '#ffd240', margin: '0', fontWeight: 'bold' }}>SALES BACKLOG</p>
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-6 text-center">
            <p style={{ fontSize: '2.5vh', color: '#ffffff', fontWeight: 'bold' }}>DAILY NET NEW ORDERS: {formatDollarValue(data.dailyNetNewSalesOrders)}</p>
          </div>
          <div className="col-lg-6 col-md-6 text-center">
            <p style={{ fontSize: '2.5vh', color: '#ffffff', fontWeight: 'bold' }}>TOTAL NET NEW ORDERS: {formatDollarValue(data.netNewSalesOrders)}</p>
          </div>
        </div>
        <Bar
          data={data.chartData}
          options={options(data.currentMonthTotal)}
          style={{ maxWidth: '100%', maxHeight: '40vh' }}
          plugins={[ChartDataLabels]}
        />

        <div className='row'>
          <div className='col-lg-4 text-center'>
            <p style={{ fontSize: '1.8vh', color: '#bab8b8' }}><b> {data.monthNow}: {formatDollarValue(data.currentMonthTotal)} </b></p>
          </div>
          <div className='col-lg-4 text-center'>
            <p style={{ fontSize: '1.8vh', color: '#bab8b8' }}><b> {data.nextMonth}: {formatDollarValue(data.nextMonthTotal)} </b></p>
          </div>
          <div className='col-lg-4 text-center'>
            <p style={{ fontSize: '1.8vh', color: '#bab8b8' }}><b> {data.monthAfterNext}: {formatDollarValue(data.monthAfterNextTotal)} </b></p>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default SalesBacklogChart;
